import {
  BreakpointObserver,
  BreakpointState,
  Breakpoints
} from '@angular/cdk/layout';
import { Location } from '@angular/common';
import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { NgxMasonryComponent } from 'ngx-masonry';
import { Observable, Subscription } from 'rxjs';
import { SCROLL_ICON_SHOW_DURATION } from 'src/app/shared/constants';
import { EnvService } from 'src/app/shared/services/env.service';
import {
  ISearchProduct
} from './../../../shared/models';
import { ApiService } from './../../../shared/services';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.less']
})
export class SearchComponent implements OnInit, AfterViewInit, OnDestroy {
  query: string;
  iPageNo: number = 0;
  iLimit: number;
  productsSubscription: Subscription;
  products: any[] = [];
  bpObserver: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Handset
  );
  totalCount = 0;
  bpSubscription: Subscription;
  isHandset: boolean;
  productsInRow = 2;
  isProductFetching = false;
  isBoardApi = false;
  isIconShow = false;
  isToggleChecked = false;

  dummyProductListings: any[] = [
    {
      displayable: true,
      main_image: '',
      height: '300px'
    },
    {
      displayable: true,
      main_image: '',
      height: '350px'

    },
    {
      displayable: true,
      main_image: '',
      height: '200px'

    },
    {
      displayable: true,
      main_image: '',
      height: '250px'
    }, {
      displayable: true,
      main_image: '',
      height: '300px'
    },
    {
      displayable: true,
      main_image: '',
      height: '400px'

    },
    {
      displayable: true,
      main_image: '',
      height: '200px'

    },
    {
      displayable: true,
      main_image: '',
      height: '280px'
    },
  ];

  @ViewChild(NgxMasonryComponent) masonry: NgxMasonryComponent;
  @ViewChildren('productItem') productItems: QueryList<ElementRef>;
  assetBaseUrl: string;

  paramSku: any;
  loadDetails: boolean;
  @ViewChild('bottomSheet') bottomSheet: TemplateRef<any>;
  loadingProducts: boolean;
  reachedLastPage: boolean;
  userType: any;
  errorMsg: any;
  totalProducts: number = -1;
  @Input() pagekey=''; 
 @Output() emitCloseBS = new EventEmitter()
  width: number;
  imgSearchUrl: string=''
  productDetails: any;


  constructor(
    private api: ApiService,
    private snackbar: MatSnackBar,
    private route: ActivatedRoute,
    private breakpointObserver: BreakpointObserver,
    private location: Location,
    public _bottomSheet: MatBottomSheet,
    private env: EnvService
  ) {
    this.userType = JSON.parse(localStorage.getItem("user"))?.authorization;

  }

  onToggleChange() {
    this.query = (this.isToggleChecked ? (this.query + ' sale') : this.query.replace(' sale', ''));
    // this.api.searchText = this.query;
    this.updateQueryString();
    this.getQueryResult();
    this.reloadMasonry('');
  }

  ngOnInit(): void {
    this.width = window.innerWidth;
    this.products = this.dummyProductListings;
    this.assetBaseUrl = this.env.assetSLBaseUrl;

    // Initial query from URL
    this.handleQuery(this.route.snapshot.queryParamMap.get('query') || '');

    // Listen for query param changes
    this.route.queryParams.subscribe(params => {
      this.handleQuery(params.query || '');
      this.updateQueryString();
    });

    // Text search updates
    this.api.searchQueryData$.subscribe(data => {
      if (data) {
        this.handleQuery(data);
        this.getQueryResult();
      }
    });

    // Image search updates
    this.imgSearchUrl = this.api.imgSearchData?.image_url || '';

    this.api.imgSearchData$.subscribe(data => {
      if (data || this.api.imgSearchData?.image_url || this.api.imgSearchData?.image_upload) {
        this.api.imgSearchData = data || this.api.imgSearchData;
        this.imgSearchUrl = data?.image_url || this.imgSearchUrl;
      } else {
        this.imgSearchUrl = '';
        this.api.imgSearchData = null;
      }

      this.getQueryResult();
    });

    // Breakpoint observer
    this.bpSubscription = this.bpObserver.subscribe((handset: BreakpointState) => {
      this.isHandset = handset.matches;
    });
  }

  private handleQuery(query: string): void {
    this.query = query;

    // Handle image_url prefix
    if (query.includes('image_url:')) {
      this.imgSearchUrl = query.replace('image_url:', '');
    }

    // Handle sale toggle
    this.isToggleChecked = query.includes('sale');

    // Normalize query based on toggle
    this.query = this.isToggleChecked
      ? (query.includes('sale') ? query : `${query} sale`)
      : query.replace(' sale', '');

    this.api.searchText = this.query;
  }

  topPosToStartShowing = 1300;
  timeout: any;

  @HostListener('window:scroll', [])
  onWindowScroll() {

    const scrollPosition = window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;



    this.isIconShow = scrollPosition >= this.topPosToStartShowing;
    const self = this;
    if (this.isIconShow) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        self.isIconShow = false;
      }, SCROLL_ICON_SHOW_DURATION);
    }
  }


  onDestroy(): void {
    this.productsSubscription.unsubscribe();
    this.bpSubscription.unsubscribe();
  }

   private  fetchProducts(page: number, isInitialLoad = false): void {
    if (this.isProductFetching || this.reachedLastPage) return;
    this.errorMsg = '';
    this.isProductFetching = true;


    if (isInitialLoad) {
      this.iPageNo = 1;
      this.iLimit = 24;
      this.products = this.dummyProductListings;
    }
    let call: any; 
    if(this.pagekey==='searchImage' &&this.api.searchProductsPayload)
    {
         this.processPayload(this.api.searchProductsPayload,page,isInitialLoad);
    } else {
      let data = null;
      if(this.location.path().includes('search?query=image_url') ){
          this.api.imgSearchData = {
            image_upload: null,
            image_url: // get the image url from query param
              this.route.snapshot.queryParamMap.get('query')?.replace('image_url:', '') || ''
          };
           
      } else {
   data = sessionStorage.getItem('imgSearchData');
    if (data) {
      this.api.imgSearchData = JSON.parse(data);
    }
      }

    if (this.api.imgSearchData || data) {
      
      call = this.api.searchProducts('sale', page, this.api.imgSearchData)
    } else {
      call = this.api
        .searchProducts(this.query, page)
    }

    this.productsSubscription = call
      .subscribe({
        next: (payload: any) => {
          this.api.searchProductsPayload = payload;
          this.processPayload(payload,page,isInitialLoad);
        },
        error: () => {
          this.isProductFetching = false;
          this.products = [];
          this.totalProducts = -1;
          this.errorMsg = 'No matching products found. Try to update the query!'
        }
      });
    }
  
  }
status=0;
async  processPayload(payload, page,isInitialLoad){
  this.status = payload.status;
         if (payload.results) {
            let { total_pages, page_size, total, results } = payload;
            const items = page_size * (total_pages-1);
            this.totalProducts = items;
            this.totalCount = total_pages > 0 ? total : 0;
            this.reachedLastPage = page === total_pages;
            const authType = '' + this.userType;
            results = results.filter(f => {
              if (authType == '0' || authType == '1') {
                return f.displayable === 'true' || f.displayable === 'preview';
              } else if (authType == '3' || authType.startsWith('7')) {
                return f.displayable === 'true' || f.displayable === 'preview' || f.displayable === 'authorized';
              } else {
                return true;
              }
            });

            if (total_pages > 0) {
             const validatedProducts = await this.processProducts(payload);

              // if (isInitialLoad) {
              //   this.products = results;
              // } else {
              //   this.products = [
              //     ...this.products.filter(f => !f.height),
              //     ...results
              //   ];
              // } 

          this.products = this.products.filter(f => !f.height);
          //         if (page === 1) {
          //   this.products = [...validatedProducts];
          // } else {
          // }
          this.products = [...this.products, ...validatedProducts];

              this.updatePageNo(page);
            } else {
              this.products = [];
            }

            this.isProductFetching = false;
          } else {
            this.isProductFetching = false;
            this.errorMsg = payload.error;
            this.products = [];
          }
  }

  getQueryResult(): void {
    this.fetchProducts(1, true);
  }

  onScroll(): void {
    if (this.isProductFetching || this.reachedLastPage) return;

    this.products.push(...this.dummyProductListings); // Preserving your existing behavior
    this.iPageNo += 1;

    this.fetchProducts(this.iPageNo);
  }

  updatePageNo(no: number) {
    const url = new URL(window.location.href);
    url.searchParams.set('pageNo', no.toString());

    const newUrl = `${window.location.pathname}?${url.searchParams.toString()}`;
    this.location.replaceState(newUrl, '', this.location.getState());
  }
  reloadMasonry(e) {
    if (this.masonry !== undefined) {
      this.masonry.reloadItems();
      this.masonry.layout();
    }
  }
  gotoTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }
 
  async processProducts(response: any) {
  const products = response.results.map((product: any) => {
    // Start with base object
    const processed: any = {
      ...product,
      loaded: false,
      padding: '14px',
      allImages: [],
      isMainImageAccessible: false, // temporary
    };

    // Collect all images
    if (product.main_product_images) {
      processed.allImages.push(...product.main_product_images.split(','));
    }
    if (product.product_images_gallery) {
      processed.allImages.push(...product.product_images_gallery.split(','));
    }

    // Flatten & assign main image
    processed.allImages = processed.allImages.flat();
    if (processed.allImages.length > 0) {
      processed.main_image = this.assetBaseUrl + processed.allImages[0];
      processed.mainImage = processed.main_image;
    }
    processed.condition = product.product_condition;
    // Map additional fields
    processed.name = product.product_name; 

    // Handle discount
    processed.percent_discount =
      product.percent_discount &&
      product.percent_discount !== '0.00' &&
      +product.percent_discount > 0 &&
      product.percent_discount !== '0'
        ? parseInt(product.percent_discount, 10)
        : '';

    return processed;
  });

  // ✅ Check all main images in parallel
  const validatedProducts = await Promise.all(
    products.map(async (p) => {
      if (p.mainImage) {
        p.isMainImageAccessible = await this.api.checkImageAccessible(
          p.mainImage
        );
      }
      return p;
    })
  );

  console.log('✅ Final validated products', validatedProducts);
  return validatedProducts;
}

 


  updateQueryString(): void {
    const params = [];
    params.push(`query=${encodeURIComponent(this.query)}`);
    if (this.iPageNo) {
      params.push(`pageNo=${this.iPageNo}`);
    }
    const paramString = params.join('&');
    this.location.replaceState(
      window.location.pathname + '?' + paramString,
      '',
      this.location.getState()
    );
  }
  ngAfterViewInit(): void {

    // this.productItems.changes.subscribe(() => {
    //   if (this.products.length > 0) {
    //     setTimeout(() => {
    //       this.masonry.reloadItems();
    //       this.masonry.layout();
    //     }, 0); // Or 100ms if needed
    //   }
    // });
  }

  ngOnDestroy(): void {
    this.api.searchText = 'What can I help you find?';
    if(this.pagekey!=='searchImage'){
      this.api.imgSearchData = null;
    } 

    sessionStorage.removeItem('imgSearchData');
  }

  toggleMobileView() {
    if (this.productsInRow === 3) {
      this.productsInRow = 1;
    } else {
      this.productsInRow += 1;
    }
  }

  getImgSearch(product) {
    this.api.imgSearchData = {
      image_upload: null,
      image_url: product.main_image
    };

    this.products = this.dummyProductListings;
    this.fetchProducts(1);
  }

  getProductData(product: any) {
    this.closeProductNav('');
    this.productDetails = product; 
    this.paramSku = typeof product ==='string'? product : product.parent_sku ? product.parent_sku : product.product_sku;

    this.loadDetails = true;

    if (this.isHandset) {
      this.openBottomSheet();
    } else {
      this.openProductNav();
    }
  }

  openBottomSheet() {
    // this.isPrdPreviewOpened=true;
    this._bottomSheet.open(this.bottomSheet);
  }

  openProductNav() {
    document.getElementById("productSidenav").style.width = "450px";
    document.getElementById('productSidenav').scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    document.body.style.backgroundColor = "rgba(0,0,0,0.4)";
    // this.api.isSideNavOpened = true;
  }

  closeProductNav(msg) {
    if (document.getElementById("productSidenav")) {
      this.loadDetails = false;
      document.getElementById("productSidenav").style.width = "0";
      document.body.style.backgroundColor = "white";
      if (msg !== 'close' && msg) {
        this.snackbar.open(msg, 'x', { duration: 3000 })
      }
      // this.api.isSideNavOpened = false;
    }
  }
  closeBototmSheet(){
    this.emitCloseBS.emit();
  }
 
}
